// Constants for better maintainability
export const BACKEND_TOKEN_PROCESSING_DELAY_MS = 100;
export const AUTH_RETRY_DELAY_MS = 1000;
export const LOADING_DELAY_MS = 300;
export const AUTH_STATE_INITIALIZATION_DELAY_MS = 1500; // Time to wait for Firebase auth state to initialize
export const LOADING_TIMEOUT_MS = 10000; // 10 second timeout to prevent infinite loading
